import axios from '../axios';
import { GET_SERVER_MONITORING_FLAGS } from '../ApiUrl';
import {
  getServerMonitoringFlagsCache,
  setServerMonitoringFlagsCache,
} from '../../utils/serverMonitoringFlagsCache';

function parseServerMonitoringFlagsResponse(res) {
  if (res.hasError) {
    const message =
      typeof res.message === 'string' && res.message.trim()
        ? res.message.trim()
        : 'Could not load server monitoring flags.';
    return { ok: false, error: message, flags: [] };
  }
  const body = res.data;
  if (body?.success === false) {
    return {
      ok: false,
      error:
        typeof body.message === 'string' && body.message.trim()
          ? body.message.trim()
          : 'Request failed.',
      flags: [],
    };
  }
  if (body?.success === true && Array.isArray(body.data)) {
    return { ok: true, error: null, flags: body.data };
  }
  return { ok: false, error: 'Unexpected response from server monitoring API.', flags: [] };
}

/**
 * GET /GetServerMonitoringFlags
 */
export const getServerMonitoringFlagsAPI = async () => {
  try {
    const response = await axios.get(GET_SERVER_MONITORING_FLAGS);
    return response;
  } catch (error) {
    console.log('getServerMonitoringFlagsAPI catch', error);
    return { hasError: true, error };
  }
};

/**
 * Returns cached flags when available; otherwise fetches and stores in memory.
 * @param {{ forceRefresh?: boolean }} [options]
 * @returns {Promise<{ ok: boolean, flags: object[], error: string|null, refreshedAt: number|null, fromCache: boolean }>}
 */
export async function loadServerMonitoringFlags({ forceRefresh = false } = {}) {
  if (!forceRefresh) {
    const cached = getServerMonitoringFlagsCache();
    if (cached?.flags) {
      return {
        ok: true,
        flags: cached.flags,
        error: null,
        refreshedAt: cached.refreshedAt ?? null,
        fromCache: true,
      };
    }
  }

  const res = await getServerMonitoringFlagsAPI();
  const parsed = parseServerMonitoringFlagsResponse(res);
  if (!parsed.ok) {
    return {
      ok: false,
      flags: [],
      error: parsed.error,
      refreshedAt: null,
      fromCache: false,
    };
  }

  const refreshedAt = Date.now();
  setServerMonitoringFlagsCache({ flags: parsed.flags, refreshedAt });

  return {
    ok: true,
    flags: parsed.flags,
    error: null,
    refreshedAt,
    fromCache: false,
  };
}
